<div class="main-content">
  <app-success-profile-verification-component *ngIf="!toggleEdit" (toggleEditor)="setToggleEdit($event)"></app-success-profile-verification-component>
  <app-failed-profile-verification-component *ngIf="toggleEdit" (toggleEditor)="setToggleEdit($event)"></app-failed-profile-verification-component>
</div>
